import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn, faChartPie, faMapLocationDot, faUpDownLeftRight, faTable, } from "@fortawesome/free-solid-svg-icons";
import { Loader, StatusMessage } from "../index";
function getPlaceholderIcon(bar, pie, table, map, drag, loader, message, warningMessage, errorMessage) {
    let icon = null;
    if (bar) {
        icon = _jsx(FontAwesomeIcon, { icon: faChartColumn, size: "8x" });
    }
    else if (pie) {
        icon = _jsx(FontAwesomeIcon, { icon: faChartPie, size: "8x" });
    }
    else if (table) {
        icon = _jsx(FontAwesomeIcon, { icon: faTable, size: "8x" });
    }
    else if (map) {
        icon = _jsx(FontAwesomeIcon, { icon: faMapLocationDot, size: "8x" });
    }
    else if (drag) {
        icon = _jsx(FontAwesomeIcon, { icon: faUpDownLeftRight, size: "6x" });
    }
    else if (loader) {
        icon = _jsx(Loader, {});
    }
    else if (warningMessage !== undefined) {
        icon = _jsx(StatusMessage, { status: "warning", message: warningMessage, bordered: true });
    }
    else if (errorMessage !== undefined) {
        icon = _jsx(StatusMessage, { status: "error", message: errorMessage, bordered: true });
    }
    return (_jsxs("div", { children: [icon, message && _jsx("p", { className: "tol-placeholder-message", children: message })] }));
}
function getPlaceholder(height, style = {}, icon, backing, opacity, clear, squareCorners) {
    if (opacity)
        style["opacity"] = opacity;
    if (squareCorners !== true)
        style["borderRadius"] = 6;
    // default placeholder
    if (backing === undefined) {
        return (_jsx("div", { style: { height: height }, children: _jsx("div", { className: clear ? "tol-placeholder-empty" : "tol-placeholder", style: style, children: _jsx("div", { className: "tol-placeholder-icons", children: icon }) }) }));
    }
    // adding a faded background to the backing contents (e.g. map behind loading)
    return (_jsxs("div", { className: "overlay-outer", children: [_jsx("div", { className: "overlay-top", style: { zIndex: 1002 }, children: _jsx("div", { style: { height: height }, children: _jsx("div", { className: "tol-placeholder-empty", children: _jsx("div", { className: "tol-placeholder-icons", children: icon }) }) }) }), _jsx("div", { className: "overlay-top", style: { zIndex: 1001 }, children: _jsx("div", { style: { height: height }, children: _jsx("div", { className: "tol-placeholder", style: style }) }) }), backing] }));
}
function Placeholder(props) {
    const { bar, pie, table, map, drag, empty, loader, opacity, clear, squareCorners, message, warningMessage, errorMessage, backing, style, } = props;
    const height = props.height !== undefined ? props.height : "100%";
    // this temporarily fills a gap - used for on load
    if (empty) {
        return _jsx("div", { style: { height: height } });
    }
    const icon = getPlaceholderIcon(bar, pie, table, map, drag, loader, message, warningMessage, errorMessage);
    return getPlaceholder(height, style, icon, backing, opacity, clear, squareCorners);
}
export default Placeholder;
